// extracted by mini-css-extract-plugin
export default {"Row":"SignUpForm_Row__VfSMw","Link":"SignUpForm_Link__zT+QG"};